import { SetCurrentRecurringPayment } from '@app/finxone-web-frontend/app/lib/actions/recurring-payments.action';
import { RecurringPaymentsRequest } from '@app/finxone-web-frontend/app/lib/services/recurring-payments-service/recurring-payments.service';
import {
  RecurringPaymentFrequency,
  RecurringPaymentResponse,
  RecurringPaymentStatus,
  mapRecurringPaymentResponse,
} from '@finxone-platform/shared/sys-config-types';
import { Store } from '@ngxs/store';
import { Observable, of } from 'rxjs';

/** Mirrors the account-service wire shape (snake_case) so the state's mapper runs in the builder too. */
export class MockRecurringPaymentsService {
  constructor(private store: Store) {}

  public getRecurringPayments(params: RecurringPaymentsRequest): Observable<RecurringPaymentResponse[]> {
    const recurringPayments: RecurringPaymentResponse[] = [
      {
        id: 'a4c8f0d2-1f4b-4a3e-9c26-5b2f1d0e7a11',
        organisation_id: 'a1724829-233c-4b05-b974-d83282120eb7',
        client_id: '15331',
        account_id: params.accountId || 'A1224777',
        mandate_id: 'MOCK-GC-BR-001',
        amount: '15.99',
        currency: 'GBP',
        frequency: RecurringPaymentFrequency.MONTH,
        collection_day: 1,
        start_date: '2025-09-01',
        end_date: '2027-09-01',
        next_collection_date: '2026-09-01',
        status: RecurringPaymentStatus.ACTIVE,
        status_reason: null,
        created_at: '2025-08-28T10:14:22.000Z',
        updated_at: '2025-08-28T10:14:22.000Z',
      },
      {
        id: 'b7d1e5a9-6c2f-4d88-8a41-3e9c7b5d2f04',
        organisation_id: 'a1724829-233c-4b05-b974-d83282120eb7',
        client_id: '15331',
        account_id: params.accountId || 'A1224777',
        mandate_id: 'MOCK-GC-BR-002',
        amount: '50.00',
        currency: 'GBP',
        frequency: RecurringPaymentFrequency.WEEK,
        collection_day: null,
        start_date: '2026-01-05',
        end_date: null,
        next_collection_date: '2026-08-17',
        status: RecurringPaymentStatus.ACTIVE,
        status_reason: null,
        created_at: '2025-12-30T09:02:11.000Z',
        updated_at: '2025-12-30T09:02:11.000Z',
      },
      {
        id: 'c2f9a3b6-8e14-4f70-b5d3-71a08c4e9d55',
        organisation_id: 'a1724829-233c-4b05-b974-d83282120eb7',
        client_id: '15331',
        account_id: params.accountId || 'A1224778',
        mandate_id: 'MOCK-GC-BR-003',
        amount: '25.00',
        currency: 'GBP',
        frequency: RecurringPaymentFrequency.DAY,
        collection_day: null,
        start_date: '2026-08-11',
        end_date: null,
        next_collection_date: '2026-08-11',
        status: RecurringPaymentStatus.PENDING_AUTHORISATION,
        status_reason: null,
        created_at: '2026-08-09T16:45:03.000Z',
        updated_at: '2026-08-09T16:45:03.000Z',
      },
      {
        id: 'd8b4c7e1-3a52-4c96-9f08-6d1b2e5a7c33',
        organisation_id: 'a1724829-233c-4b05-b974-d83282120eb7',
        client_id: '15331',
        account_id: params.accountId || 'A1224777',
        mandate_id: 'MOCK-GC-BR-004',
        amount: '450.00',
        currency: 'GBP',
        frequency: RecurringPaymentFrequency.BIWEEKLY,
        collection_day: null,
        start_date: '2025-04-01',
        end_date: '2026-04-01',
        next_collection_date: null,
        status: RecurringPaymentStatus.CANCELLED_BY_CUSTOMER,
        status_reason: 'Cancelled by customer',
        created_at: '2025-03-22T11:38:47.000Z',
        updated_at: '2026-04-01T11:38:47.000Z',
      },
      {
        id: 'e1a6d0c4-9b73-4e21-8c57-4f2a9b6d1e88',
        organisation_id: 'a1724829-233c-4b05-b974-d83282120eb7',
        client_id: '15331',
        account_id: params.accountId || 'A1224779',
        mandate_id: 'MOCK-GC-BR-005',
        amount: '32.50',
        currency: 'GBP',
        frequency: RecurringPaymentFrequency.MONTH,
        collection_day: 15,
        start_date: '2024-11-15',
        end_date: '2026-02-15',
        next_collection_date: null,
        status: RecurringPaymentStatus.EXPIRED,
        status_reason: null,
        created_at: '2024-11-10T08:20:00.000Z',
        updated_at: '2026-02-15T08:20:00.000Z',
      },
      {
        id: 'f5c2b8a7-4d61-4b09-a3e8-2c7d5f1a9b60',
        organisation_id: 'a1724829-233c-4b05-b974-d83282120eb7',
        client_id: '15331',
        account_id: params.accountId || 'A1224777',
        mandate_id: 'MOCK-GC-BR-006',
        amount: '289.00',
        currency: 'GBP',
        frequency: RecurringPaymentFrequency.MONTH,
        collection_day: 1,
        start_date: '2024-06-01',
        end_date: '2026-06-01',
        next_collection_date: null,
        status: RecurringPaymentStatus.ENDED,
        status_reason: null,
        created_at: '2024-05-24T14:07:35.000Z',
        updated_at: '2026-06-01T14:07:35.000Z',
      },
      {
        id: '0a3e7d59-2b48-4c15-9e60-8b4f3c2a1d77',
        organisation_id: 'a1724829-233c-4b05-b974-d83282120eb7',
        client_id: '15331',
        account_id: params.accountId || 'A1224778',
        mandate_id: 'MOCK-GC-BR-007',
        amount: '1200.00',
        currency: 'USD',
        frequency: RecurringPaymentFrequency.MONTH,
        collection_day: 10,
        start_date: '2025-07-10',
        end_date: null,
        next_collection_date: '2027-01-10',
        status: RecurringPaymentStatus.ACTIVE,
        status_reason: null,
        created_at: '2025-07-02T13:55:19.000Z',
        updated_at: '2025-07-02T13:55:19.000Z',
      },
    ];

    // Nothing selects a mandate in the builder — there is no navigation from the list — so the first
    // mock stands in as the current one, letting detail templates render real values on the canvas.
    this.store.dispatch(new SetCurrentRecurringPayment(mapRecurringPaymentResponse(recurringPayments[0])));

    return of(recurringPayments);
  }
}
